<div class="address-container" [ngClass]="{'nmodal': typeModal === 2}">
  <form [formGroup]="formAddress" class="address-group" [class.address-group__not-modal]="typeModal === 2">
    <div class="address-title-and-closed">
      <h3 class="title">{{ titleModal }}</h3>
      <button class="btn btn-close" (click)="validtorModal()">
        <img src="../../../../assets/svgs/close_btn.svg" alt="Fechar" *ngIf="typeModal === 1">
        <img src="../../../../assets/svgs/i_dot_options.svg"alt="Fechar" *ngIf="typeModal === 2">
      </button>
      <ul class="dp-list" *ngIf="openDropDown">
        <li class="dp-item">
          <a class="dp-action" (click)="sendRouter()">
            <span>Editar</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="address-descriptions">
      <p class="type" *ngIf="subTypeItem">{{ subTypeItem }}</p>
      <h4 class="corporation">{{ enterpriseName }}</h4>
      <div class="address">
        <!-- {{ neighborhood }} -->
        <span>{{ returnAddress() }}</span>
      </div>
    </div>
    <div class="form-address"
      *ngIf="code === 3 || code === 17 || code === 7 || code === 8 || code === 19 || code === 38 || code === 4">
      <lib-input-checkbox class="tower" [id]="'single_tower'" formControlName="single_tower"
        name="single_tower" label="Torre única"></lib-input-checkbox>
      <div class="form-control">
        <app-input 
          class="input-control" id="number_name_tower"
          [label]="'Nome ou número da torre *'"
          maxlength="100"
          formControlName="number_name_tower"
          [messageError]="'Nome ou número da torre requerido'"
          [error]="formAddress.get('number_name_tower').invalid"
          [placeholder]="'Ex: Torre A'">
        </app-input>
        <div class="align-input">
          <app-input 
            class="input-control" id="floor"
            [label]="'Andar *'"
            formControlName="floor"
            [messageError]="'Andar requerido'"
            [error]="formAddress.get('floor').invalid"
            [placeholder]="'Ex: 10'"
            maxlength="4"
            (input)="removeCaracter($event)">
          </app-input>
          <app-input 
            class="input-control" id="unity"
            [label]="'Unidade *'"
            maxlength="20"
            formControlName="unity"
            [messageError]="'Unidade requerida'"
            [error]="formAddress.get('unity').invalid"
            [placeholder]="'Ex: 101'">
          </app-input>
        </div>
      </div>
    </div>
    <div class="inputzone">
      <app-input
        id="value_zone"
        [label]="'Zona de valor (portal/marketing) *'"
        formControlName="value_zone"
        maxlength="100"
        [messageError]="'Zona de valor (portal/marketing) requerida'"
        [error]="formAddress.get('value_zone').invalid" [placeholder]="''">
      </app-input>
    </div>
    <div class="button-container" *ngIf="typeModal === 1">
      <button class="btn btn-cancel">Cancelar</button>
      <button class="btn btn-continue" (click)="sendRouter()">Continuar</button>
    </div>
  </form>
</div>